import { render, staticRenderFns } from "./ArtisioTableSelectionModal.vue?vue&type=template&id=2da8e1c6&scoped=true"
import script from "./ArtisioTableSelectionModal.vue?vue&type=script&lang=js"
export * from "./ArtisioTableSelectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8e1c6",
  null
  
)

export default component.exports